// 在此文件定义枚举，然后通过export.default导出，代码生成时可以进行选择，选择后代码生成引擎会自动应用该枚举对字段进行解析

// const <枚举名称> = {
//   <枚举项>: {
//     label: <label>,
//     value: <value>
//   }
// }

/**
 * 业务类别
 * @type {{}}
 */
const BUSINESS_CATEGORY = {
  DOMESTIC_TRADE: {
    label: '内贸',
    value: 0,
    alias: 'GHNMSE',
    pathType: 'jzxnm'
  },
  FOREIGN_TRADE: {
    label: '外贸',
    value: 1,
    alias: 'GHWMSE',
    pathType: 'jzxwm'
  }
}

/**
 * 合同类型
 */
const CONTRACT_TYPE = {
  // 客户、供应商
  CUSTOMER: {
    label: '客户',
    value: 0
  },
  SUPPLIER: {
    label: '供应商',
    value: 1
  }
}

/**
 * 合同状态
 */
const CONTRACT_STATUS = {
  // 待归档、已归档
  WAIT_ARCHIVE: {
    label: '待归档',
    value: 0
  },
  ARCHIVED: {
    label: '已归档',
    value: 1
  }
}

/**
 * 作废状态
 */
const CANCELLATION_STATUS = {
  NOT_CANCELLED: {
    label: '未作废',
    value: 0
  },
  CANCELLED: {
    label: '已作废',
    value: 1
  }
}

/**
 * 客户类型
 */
const CUSTOMER_TYPE = {
  CUSTOMER: {
    label: '客户',
    value: 0,
    alias: 'kehu'
  },
  SUPPLIER: {
    label: '供应商',
    value: 1,
    alias: 'supplier'
  },
  OUR_COMPANY: {
    label: '本方公司',
    value: 2,
    alias: 'ourCompany'
  }
}

/**
 * 客户联系人类型
 */
const CUSTOMER_CONTACT_TYPE = {
  // 联系人、代理、司机
  CONTACT: {
    label: '联系人',
    value: 0
  },
  AGENT: {
    label: '代理人',
    value: 1
  },
}

/**
 * 付款方式
 */
const PAYMENT_METHOD = {
  // 到付/月结
  PAY_ON_DELIVERY: {
    label: '票结',
    value: '0',
    default: false
  },
  MONTHLY_STATEMENT: {
    label: '月结',
    value: '1',
    default: true
  }
}

/**
 * 业务状态
 */
const BUSINESS_STATUS = {
  WAIT_EXECUTE: {
    label: '货源已创建',
    value: 10,
    tagType: 'warning'
  },
  EXECUTING: {
    label: '清单导入完成',
    value: 20,
    tagType: 'primary'
  },
  YUPEIZAI: {
    label: '预配载完成',
    value: 30,
    tagType: 'success'
  },
  YIXIAFA: {
    label: '已下发',
    value: 40,
    tagType: 'success'
  },
  ZHIDINGXIAFA: {
    label: '调度已指定',
    value: 50,
    tagType: 'success'
  },
  KAISHIXIANCHANG: {
    label: '开始现场配载',
    value: 60,
    tagType: 'success'
  },
  COMPLETED: {
    label: '配载完成',
    value: 70,
    tagType: 'success'
  },
}

/**
 * 集装箱 - 订舱状态
 */
const BOOKING_STATUS = {
  // 待订舱/已订舱/已装箱/已进仓/已放行/完成/已取消
  WAIT_BOOKING: {
    label: '待订舱',
    value: 0
  },
  BOOKED: {
    label: '已订舱',
    value: 1
  },
  PACKED: {
    label: '已装箱',
    value: 2
  },
  IN_WAREHOUSE: {
    label: '已进仓',
    value: 3
  },
  RELEASED: {
    label: '已放行',
    value: 4
  },
  COMPLETED: {
    label: '完成',
    value: 5
  }
}

/**
 * 报关状态
 */
export const CUSTOMS_STATUS = {
  // 未报关
  UNCUSTOMS: {
    label: '未报关',
    value: 0
  },
  // 报关完成
  CUSTOMS_COMPLETED: {
    label: '已报关',
    value: 1
  }
}

/**
 * 运输类型
 */
const TRANSPORT_TYPE = {
  // 车/船
  CAR: {
    label: '车',
    value: 0
  },
  SHIP: {
    label: '船',
    value: 1
  }
}

/**
 * 港前运输方式
 *
 * 直拖、陆改水、铁路、内装
 */
const PRE_PORT_TRANSPORT_TYPE = {
  CAR: {
    label: '直拖',
    value: 0
  },
  LAND_CHANGE_SEA: {
    label: '陆改水',
    value: 1
  },
  RAILWAY: {
    label: '铁路',
    value: 2
  },
  INTERNAL_PACKING: {
    label: '内装',
    value: 3
  }
}

/**
 * 是否危险品
 * 普货、危险品
 */
const IS_DANGEROUS_GOODS = {
  NORMAL: {
    label: '普货',
    value: 1
  },
  DANGEROUS: {
    label: '危险品',
    value: 2
  }
}

/**
 * 订单类型
 */
const ORDER_TYPE = {
  // 市场/内部委派
  INTERNAL_DELEGATION: {
    label: '内部委派',
    value: 1
  },
  MARKET: {
    label: '市场',
    value: 0
  }
}

/**
 * 收支方向
 */
const INCOME_EXPENSE_DIRECTION = {
  // 应收/应付
  INCOME: {
    label: '应收',
    value: 0
  },
  EXPENSE: {
    label: '应付',
    value: 1
  }
}

/**
 * 对账状态
 *
 * 待对账、已提交对账、已驳回
 */
const ACCOUNT_STATUS = {
  WAIT_ACCOUNT: {
    label: '待对账',
    value: 0
  },
  SUBMITTED_ACCOUNT: {
    label: '已提交对账',
    value: 1
  },
  REJECTED_ACCOUNT: {
    label: '已驳回',
    value: 2
  }
}

/**
 * 业务类型
 *
 * 集装箱/件杂货/拖车
 */
const BUSINESS_TYPE = {
  CONTAINER_WM: {
    label: '集装箱外贸',
    value: 0,
    alias: 'jzxwm',
    title: 'GHWMSE',
    pinyinCoding: 'HD'
  },
  CONTAINER_NM: {
    label: '集装箱内贸',
    value: 1,
    title: 'GHNMSE',
    alias: 'jzxnm',
    pinyinCoding: 'HDN'
  },
  GOODS: {
    label: '件杂货',
    value: 2,
    alias: 'jzh',
    title: 'GHSZ',
    pinyinCoding: 'JZH'
  },
  CARGO_HAULAGE: {
    label: '拖车',
    value: 3,
    alias: 'tc',
    title: 'GHTC',
    pinyinCoding: 'TC'
  }
}

/**
 * 账单生成状态
 */
const BILL_STATUS = {
  // 待生成/已生成
  WAIT_GENERATE: {
    label: '待生成',
    value: 0
  },
  GENERATED: {
    label: '已生成',
    value: 1
  }
}
/**
 * 货物来源
 */
const CARGO_SOURCE = {
  MANUAL: {
    label: '手动添加',
    value: 0
  },
  STOCK: {
    label: '库存',
    value: 1
  }
}

/**
 * 对账单类型
 *
 * 提交、驳回
 */
const ACCOUNT_BILL_TYPE = {
  SUBMIT: {
    label: '提交',
    value: 0
  },
  REJECT: {
    label: '驳回',
    value: 1
  }
}

/**
 * 拖车业务类型
 *
 * 集装箱、件杂货
 */
const CARGO_HAULAGE_BUSINESS_TYPE = {
  CONTAINER: {
    label: '集装箱',
    value: 0
  },
  GOODS: {
    label: '件杂货',
    value: 1
  }
}

/**
 * 拖车运单状态
 *
 * 待司机接单、司机已接单、已完成
 */
const CARGO_HAULAGE_BILL_STATUS = {
  WAIT_DRIVER_ORDER: {
    label: '待司机接单',
    value: 0
  },
  DRIVER_ORDERED: {
    label: '司机已接单',
    value: 1
  },
  COMPLETED: {
    label: '已完成',
    value: 2
  }
}

/**
 * 承运类型
 *
 * 自有、外协
 */
const CARRIER_TYPE = {
  OWN: {
    label: '自有',
    value: 0
  },
  COOPERATE: {
    label: '外协',
    value: 1
  }
}

/**
 * 承运单状态
 *
 * 待分配、已分配、已完成
 */
const CARRIER_BILL_STATUS = {
  WAIT_ALLOCATE: {
    label: '待分配',
    value: 0
  },
  ALLOCATED: {
    label: '已分配',
    value: 1
  },
  COMPLETED: {
    label: '已完成',
    value: 2
  }
}

/**
 * 收入账单状态
 * 待收款/已收款/已作废
 */
const INCOME_BILL_STATUS = {
  WAIT_PAYMENT: {
    label: '待收款',
    value: 0,
    tagType: 'primary'
  },
  COLLECTED: {
    label: '已收款',
    value: 1,
    tagType: 'success'
  }
}

/**
 * 供应商成本商务账单状态
 */
const COST_BILL_STATUS = {
  WAIT_GENERATE: {
    label: '待生成财务账单',
    value: 0,
    tagType: 'warning'
  },
  GENERATED: {
    label: '已生成财务账单',
    value: 1,
    tagType: 'success'
  },
}

/**
 * 收款状态
 *
 * 待收款、部分收款、已收款
 */
const COLLECTION_STATUS = {
  WAIT_COLLECTION: {
    label: '待收款',
    value: 0
  },
  PARTIAL_COLLECTION: {
    label: '部分收款',
    value: 1
  },
  COLLECTED: {
    label: '已收款',
    value: 2
  }
}

/**
 * 客户收入账单状态
 *
 * 待生成财务账单、已生成财务账单
 */
const CUSTOMER_INCOME_BILL_STATUS = {
  WAIT_GENERATE: {
    label: '待生成财务账单',
    value: 0,
    tagType: 'warning'
  },
  GENERATED: {
    label: '已生成财务账单',
    value: 1,
    tagType: 'success'
  }
}

/**
 * BuCost.genBillFinanceStatus
 */
const COST_BILL_FINANCE_STATUS = {
  WAIT_GENERATE: {
    label: '待生成',
    value: 0,
    tagType: 'warning'
  },
  GENERATED: {
    label: '已生成',
    value: 1,
    tagType: 'success'
  }
}
const BILL_INCOME_FINANCE_STATUS = {
  WAIT: {
    label: '未提交金蝶',
    value: 0,
    tagType: 'warning'
  },
  COMPLETE: {
    label: '已提交金蝶',
    value: 1,
    tagType: 'success'
  }
}

const BILL_COST_FINANCE_STATUS = {
  WAIT: {
    label: '未提交金蝶',
    value: 0,
    tagType: 'warning'
  },
  COMPLETE: {
    label: '已提交金蝶',
    value: 1,
    tagType: 'success'
  }
}

/**
 * 申请状态
 *
 * 待申请、部分申请、已申请
 */
const APPLY_STATUS = {
  WAIT_APPLY: {
    label: '待申请',
    value: 0,
    tagType: 'primary'
  },
  PARTIAL_APPLY: {
    label: '部分申请',
    value: 1,
    tagType: 'warning'
  },
  APPLIED: {
    label: '已申请',
    value: 2,
    tagType: 'success'
  }
}

/**
 * 付款状态
 */
const PAYMENT_STATUS = {
  // 待付款、部分付款、已付款
  WAIT_PAYMENT: {
    label: '待付款',
    value: 0
  },
  // PARTIAL_PAYMENT: {
  //   label: '部分付款',
  //   value: 1
  // },
  PAID: {
    label: '已付款',
    value: 2
  },
  CLOSED: {
    label: '已关闭',
    value: 9
  }
}
/**
 * 付款分类
 * 业务付款、保证金支付、理赔款支付、预付账款
 */
const PAYMENT_CATEGORY = {
  SALES_RECEIPT: {
    label: '业务付款',
    value: 0
  },
  MARGIN_RETURN: {
    label: '保证金支付',
    value: 1
  },
  CLAIM_RETURN: {
    label: '理赔款支付',
    value: 2
  },
  PREPAYMENT: {
    label: '预付账款',
    value: 3
  }
}

/**
 * 收款单分类
 * 销售回款、保证金退回、理赔款退回、预收账款
 */
const RECEIPT_CATEGORY = {
  SALES_RECEIPT: {
    label: '销售回款',
    value: 0
  },
  MARGIN_RETURN: {
    label: '保证金退回',
    value: 1
  },
  CLAIM_RETURN: {
    label: '理赔款退回',
    value: 2
  },
  PREPAYMENT: {
    label: '预收账款',
    value: 3
  }
}

/**
 * 收款方式
 */
const RECEIPT_METHOD = {
  // 现汇（银行转账）、银行承兑、商业承兑、港易单
  BANK_CASH: {
    label: '银行转账',
    value: 0
  },
  BANK_PROMISSORY: {
    label: '银行承兑',
    value: 1
  },
  COMMERCIAL_PROMISSORY: {
    label: '商业承兑',
    value: 2
  },
  PORT_DOCUMENT: {
    label: '港易单',
    value: 3
  }
}

/**
 * 开票状态
 *
 * 待开票、部分开票、已开票
 */
const INVOICE_STATUS = {
  WAIT_INVOICE: {
    label: '待开票',
    value: 0,
    tagType: 'warning'
  },
  PARTIAL_INVOICE: {
    label: '部分开票',
    value: 1,
    tagType: 'warning'
  },
  INVOICED: {
    label: '已开票',
    value: 2,
    tagType: 'success'
  }
}

/**
 * 收票状态
 */
const RECEIPT_STATUS = {
  // 待收票、部分收票、已收票
  WAIT_RECEIPT: {
    label: '待收票',
    value: 0
  },
  PARTIAL_RECEIPT: {
    label: '部分收票',
    value: 1
  },
  RECEIPTED: {
    label: '已收票',
    value: 2
  }
}

/**
 * 核销状态
 *
 * 待核销、部分核销、已核销
 */
const WRITTEN_OFF_STATUS = {
  WAIT_WRITTEN_OFF: {
    label: '待核销',
    value: 0
  },
  PARTIAL_WRITTEN_OFF: {
    label: '部分核销',
    value: 1
  },
  WRITTEN_OFF: {
    label: '已核销',
    value: 2
  }
}

/**
 * 是否空发票
 */
const IS_EMPTY_INVOICE = {
  // 空、非空
  EMPTY: {
    label: '空',
    value: 0
  },
  NOT_EMPTY: {
    label: '非空',
    value: 1
  }
}

/**
 * 发票种类
 */
const INVOICE_TYPE = {
  // 数电票、专票、普票
  SPECIAL_INVOICE: {
    label: '专票',
    value: 0
  },
  ORDINARY_INVOICE: {
    label: '普票',
    value: 2
  },
  ROLL_INVOICE: {
    label: '卷票',
    value: 41
  },
  ELECTRONIC_ORDINARY_INVOICE: {
    label: '电子普票',
    value: 51
  },
  ELECTRONIC_SPECIAL_INVOICE: {
    label: '电子专票',
    value: 52
  },
  FULL_ELECTRONIC_SPECIAL_INVOICE: {
    label: '全电专票',
    value: 81
  },
  FULL_ELECTRONIC_ORDINARY_INVOICE: {
    label: '全电普票',
    value: 82
  }
}

/**
 * 发票方向
 */
const INVOICE_DIRECTION = {
  // 销项/进项
  OUTPUT: {
    label: '销项',
    value: 0
  },
  INPUT: {
    label: '进项',
    value: 1
  }
}

/**
 * 发票核销工作台数据来源
 *
 * 发票、账单、核销记录
 */
const INVOICE_WRITE_OFF_WORKBENCH_SOURCE = {
  INVOICE: {
    label: '发票',
    value: 'invoice'
  },
  BILL: {
    label: '账单',
    value: 'bill'
  },
  WRITE_OFF_RECORD: {
    label: '核销记录',
    value: 'writeOffRecord'
  }
}

/**
 * 发票生成状态
 */
const INVOICE_GENERATE_STATUS = {
  // 生成中,已生成
  GENERATING: {
    label: '生成中',
    value: 0
  },
  GENERATED: {
    label: '已生成',
    value: 1
  }
}

/**
 * 是否入库
 */
const ENTRY_FLAG = {
  // 销项/进项
  IS: {
    label: '是',
    value: 1
  },
  NO: {
    label: '否',
    value: 0
  }
}

/**
 * 附件业务类型
 */
const ATTACHMENT_BUSINESS_TYPE = {
  CONTRACT: {
    label: '未盖章合同',
    value: 10
  },
  CONTRACT_SEAL: {
    label: '单章合同',
    value: 11
  },
  CONTRACT_SEAL_DOUBLE: {
    label: '双章合同',
    value: 12
  },
  BU_JZX: {
    label: '集装箱业务',
    value: 100
  },
  BU_JZX_TD: {
    label: '集装箱提单',
    value: 101
  },
  BU_JZXNM: {
    label: '集装箱内贸业务',
    value: 105
  },
  BU_JZXNM_TD: {
    label: '集装箱内贸提单',
    value: 106
  },
  BU_JZH: {
    label: '件杂货业务',
    value: 110
  },
  BU_TC: {
    label: '拖车业务',
    value: 120
  },
  INVOICE: {
    label: '发票',
    value: 200
  },
  INCOME_BILL: {
    label: '客户收入账单',
    value: 300
  },
  INCOME_BILL_FINANCE: {
    label: '财务收入账单',
    value: 303
  },
  INVOICE_APPLY: {
    label: '开票申请',
    value: 301
  },
  INCOME_PAYMENT: {
    label: '收款单',
    value: 302
  },
  COST_BILL: {
    label: '成本账单',
    value: 320
  },
  COST_BILL_FINANCE: {
    label: '财务成本账单',
    value: 304
  },
  COST_PAYMENT: {
    label: '付款单',
    value: 321
  },
  COST_APPLY: {
    label: '付款申请单',
    value: 322
  },
  SHIP_AGENCY: {
    label: '船代',
    value: 332
  },
  SHIP: {
    label: '船舶',
    value: 342
  },
  SCENE_IMAGE: {
    label: '现场照片',
    value: 343
  },
  SCENE_BAD_IMAGE: {
    label: '破损照片',
    value: 344
  },
  SCENE_WAYBill_IMAGE: {
    label: '运单照片',
    value: 345
  },
  SHIP_GOODS_STOWAGE: {
    label: '海船货物配载图',
    value: 346
  },
}

/**
 * 操作日志
 */
const OPER_LOG_TYPE = {
  // 收入账单、收款单、开票申请、开票核销
  // 成本账单、付款申请单、付款单、付款核销
  // 发票
  INCOME_BILL: {
    label: '收入账单',
    value: 100
  },
  INCOME_BILL_FINANCE: {
    label: '财务收入账单',
    value: 101
  },
  INCOME_PAYMENT: {
    label: '收款单',
    value: 110
  },
  INVOICE_APPLY: {
    label: '开票申请',
    value: 120
  },
  INVOICE_VERIFY: {
    label: '开票核销',
    value: 130
  },
  COST_BILL: {
    label: '成本账单',
    value: 200
  },
  COST_BILL_FINANCE: {
    label: '财务成本账单',
    value: 201
  },
  COST_PAYMENT: {
    label: '付款单',
    value: 210
  },
  COST_VERIFY: {
    label: '付款核销',
    value: 220
  },
  INVOICE: {
    label: '发票',
    value: 300
  },
}

/**
 * 提单附件来源
 */
const LADING_FILE_SOURCE = {
  // 导入收入、导入成本、附件上传
  IMPORT_INCOME: {
    label: '导入收入',
    value: '1'
  },
  IMPORT_COST: {
    label: '导入成本',
    value: '2'
  },
  UPLOAD: {
    label: '附件上传',
    value: '3'
  },
  BILL_SETTLEMENT: {
    label: '提交对账',
    value: '4'
  },
  IMPORT_COST_BATCH: {
    label: '批量导入费用',
    value: '5'
  },
}

/**
 * 入库类型
 */
const IN_STOCK_TYPE = {
  ALLOT: {
    label: '调拨入库',
    value: 10
  },
  PURCHASE: {
    label: '采购入库',
    value: 20
  }
}
/**
 * 库存变更历史-操作类型
 */
const STOCK_CHANGE_HISTORY_TYPE = {
  INSTOCK: {
    label: '入库',
    value: 10
  },
  OUTSTOCK: {
    label: '出库',
    value: 20
  },
  ALLOTSTOCK: {
    label: '调拨',
    value: 30
  }
}

/**
 * 费用类型-收入类
 */
const COST_TYPE_INCOME = {
  INCOME: {
    label: 'I',
    value: 'I'
  },
  INCOME_ONLY: {
    label: 'I1',
    value: 'I1'
  }
}

/**
 * 费用类型-成本类
 */
const COST_TYPE_EXPENSE = {
  EXPENSE: {
    label: 'C',
    value: 'C'
  },
  EXPENSE_ONLY: {
    label: 'C1',
    value: 'C1'
  },
}


/**
 * 通用类-是否
 */
const YES_OR_NO = {
  YES: {
    label: '是',
    value: 1
  },
  NO: {
    label: '否',
    value: 0
  },
}
/**
 * 生成账单名称的时候用  S(收) F(付)   付
 */
const BILL_PAY_TYPE = {
  // 生成中,已INCOME成
  INCOME: {
    label: '收',
    value: 'S'
  },
  COST: {
    label: '付',
    value: 'F'
  }
}
/**
 * 资金账户类型  RMB USD
 */
const CUSTOMER_ACCOUNT_TYPE = {
  EXPENSE: {
    label: 'RMB',
    value: 'RMB'
  },
  EXPENSE_ONLY: {
    label: 'USD',
    value: 'USD'
  },
}

/**
 * 件杂货结算单位
 */
const BUILK_SETTLEMENT_UNIT = {
  A: {
    label: '件',
    value: 0
  },
  TON: {
    label: '吨',
    value: 1
  },
}
/**
 * 件杂货运输方式
 */
const BUILK_TRANSPORT_TYPE = {
  BARGE: {
    label: '驳船',
    value: 0
  },
  SEA: {
    label: '海船',
    value: 1
  },
  CAR: {
    label: '汽运',
    value: 2
  },
}

// inventoryStatus 未在库，在库
const BUILK_INVENTORY_STATUS = {
  NOT_IN_STOCK: {
    label: '未在库',
    value: 0
  },
  IN_STOCK: {
    label: '在库',
    value: 1
  },
  // PART_IN_STOCK: {
  //   label: '部分在库',
  //   value: 2
  // }
}

// operationType 入库、出库、调拨
const BUILK_OPERATION_TYPE = {
  IN: {
    label: '入库',
    value: 0
  },
  OUT: {
    label: '出库',
    value: 1
  },
  TRANSFER: {
    label: '调拨',
    value: 2
  }
}
const BILL_FINANCE_COMMIT_STATUS = {
  IN: {
    label: '提交成功',
    value: 0,
    tagType: 'success'
  },
  OUT: {
    label: '提交失败',
    value: 1,
    tagType: 'danger'
  },
  TRANSFER: {
    label: '已退回',
    value: 2,
    tagType: 'warning'
  }
}
/**
 * 件杂货 - 下程装货状态
 */
const BUILK_NEXT_STATUS = {
  NOT_NEXT: {
    label: '下程未装货',
    value: 0
  },
  // PART_NEXT: {
  //   label: '下程已装部分',
  //   value: 1
  // },
  FINISH: {
    label: '已被下程装完',
    value: 2
  }
}

//  进口 出口
const IMPORT_EXPORT_TYPE = {
  IN: {
    label: '进口',
    value: 0
  },
  OUT: {
    label: '出口',
    value: 1
  }
}
//  重箱 空箱
const EMPTY_FULL_TYPE = {
  ZHONG: {
    label: '重箱',
    value: 1
  },
  KONG: {
    label: '空箱',
    value: 0
  }
}
//  重箱 空箱
const COST_TYPE = {
  INCOME: {
    label: '收入',
    value: 1
  },
  COST: {
    label: '成本',
    value: 0
  }
}
/**
 * 客户类型
 */
const CUSTOMER_NEW_TYPE = {
  HYWTF: {
    label: '海运委托方',
    value: 0,
  },
  GCZDF: {
    label: '钢厂终端方',
    value: 1,
  }
}

/**
 * 与船东关系类型
 */
const SHIPOWNER_RELATION_TYPE = {
  BENREN: {
    label: '本人',
    value: 0,
  },
  QINSHU: {
    label: '亲属',
    value: 1,
  },
  PENGYOU: {
    label: '朋友',
    value: 2,
  },
  OTHER: {
    label: '其他',
    value: 3,
  }
}
/**
 * 与船东关系类型
 */
const SHIP_TYPE = {
  HAI: {
    label: '海船',
    value: 1,
  },
  BO: {
    label: '驳船',
    value: 2,
  }
}

/**
 * 货源类型
 */
const GOODS_SOURCE_TYPE = {
  HAI: {
    label: '海船',
    value: 0,
  },
  GANG: {
    label: '钢厂直发',
    value: 1,
  },
  OTHER: {
    label: '其他',
    value: 2,
  }
}

/**
 * 船代付款类型
 * 先付 ，月结、季结      跟船走
 */
const PAYMENT_CYCLE_TYPE = {
  XIANFU: {
    label: '现付',
    value: 1,
  },
  YUEJIE: {
    label: '月结',
    value: 2,
  },
  JIJIE: {
    label: '季结',
    value: 3,
  },
  GENCHUANZOU: {
    label: '跟船走',
    value: 4,
  }
}

/**
 * 船代付款类型
 * 先付 ，月结、季结      跟船走
 */
const INVENTORY_TYPE = {
  qingdan: {
    label: '货物清单',
    value: 0,
  },
  luodi: {
    label: '落地清单',
    value: 1,
  },
}

/**
 * 船装货状态
 *
 */
const BULK_SCENE_SHIP_STOWAGE_STATUS = {
  LOAD_GOODS_LOADING: {
    label: '配载中',
    value: 10
  },
  LOAD_GOODS_SUCC: {
    label: '配载完成',
    value: 20
  }
}

/**
 * 运单状态
 */
const BULK_WAYBILL_STATUS = {
  LOAD_GOODS_LOADING: {
    label: '配载中',
    value: 10
  },
  LOAD_GOODS_SUCC: {
    label: '配载完成',
    value: 20
  },
  TRANSPORTATION_LOADING: {
    label: '运输途中',
    value: 30
  },
  UNLOAD_GOODS_LOADING:{
    label: '卸货中',
    value: 40
  },
  UNLOAD_GOODS_SUCC:{
    label: '卸货完成',
    value: 50
  }
}
/**
 * 收入清单状态
 * 费用状态10确认单价20审批中30已通过
 */
const INCOME_INVENTORY_APPROVAL_STATUS = {
  CONFIRM_UNIT_PRICE: {
    label: '待审批',
    value: 10
  },
  APPROVE_ING: {
    label: '审批中',
    value: 20
  },
  APPROVAL_SUCC: {
    label: '审批通过',
    value: 30
  },
  REJECT: {
    label: '审批撤回',
    value: 40
  },
  APPROVAL_FAIL: {
    label: '审批驳回',
    value: -10
  }
}
/**
 * 收入提交待对账状态
 */
const INCOME_INVENTORY_STATUS = {
  UN_SUBMIT: {
    label: '价格确认中',
    value: 0
  },
  SUBMITTED: {
    label: '已提交待对账',
    value: 1
  },
  REJECT: {
    label: '被撤回',
    value: -1
  }
}

/**
 * 成本清单状态
 */
const COST_INVENTORY_STATUS = {
  UN_SUBMIT: {
    label: '价格确认中',
    value: 10
  },
  SUBMITTED: {
    label: '已提交付款申请',
    value: 20
  },
  REJECT: {
    label: '被撤回',
    value: -10
  }
}


/**
 * 收入提交账单状态
 */
const INCOME_INVENTORY_BILL_STATUS = {
  UN_SUBMIT: {
    label: '未生成对账单',
    value: 0
  },
  SUBMITTED: {
    label: '已生成对账单',
    value: 1
  },
}
/**
 * 成本清单状态
 * 费用状态10确认单价20审批中30已通过
 */
const COST_PRICE_CONFIRM_INVENTORY_STATUS = {
  APPROVAL_SUCC: {
    label: '已提交',
    value: 30
  },
  APPROVAL_FAIL: {
    label: '已撤回',
    value: -10
  }
}
/**
 * 成本明细状态
 * 费用状态0待提交10提交到付款单-10已撤回
 */
const COST_PRICE_CONFIRM_INFO_STATUS = {
  DAITIJIAO: {
    label: '待提交付款单',
    value: 0
  },
  YTIJIAO: {
    label: '已提交付款单',
    value: 1
  }
}

/**
 * 付款类型
 * 费用状态10确认单价20审批中30已通过
 */
const PAYMENT_TYPE = {
  WANGYIN: {
    label: '网银',
    value: 10
  },
  XIANJIN: {
    label: '现金',
    value: 20
  },
  CHENGDUI: {
    label: '承兑',
    value: 30
  },
}
/**
 * 工作时段
 */
const WORKING_HOURS_TYPE = {
  BAITIAN: {
    label: '白天',
    value: 10
  },
  CHENGDUI: {
    label: '晚上',
    value: 20
  },
  SHANGWU: {
    label: '上午',
    value: 30
  },
  XIANJIN: {
    label: '下午',
    value: 40
  },
  SHANGBANYE: {
    label: '上半夜',
    value: 50
  },
  XIABANYE: {
    label: '下半夜',
    value: 60
  }
}
const AUDIT_STATUS = {
  PENDING: {
    label: '待审核',
    value: -1,
    show:true
  },
  SHENHE: {
    label: '审核中',
    value: 1,
    show:true
  },
  APPROVE: {
    label: '审核通过',
    value: 2,
    show:false
  },
  REJECT: {
    label: '审核拒绝',
    value: 3,
    show:true
  },
}
const WAYBILL_STATUS = {
  LOAD_START: {
    label: '开始装船',
    value: 10
  },
  LOAD_COMPLETE: {
    label: '装船完成',
    value: 20
  },
  UNLOAD_PORT_ARRIVED: {
    label: '航行中',
    value: 30
  },
  PAIDUI: {
    label: '排队待卸中',
    value: 35
  },
  UNLOAD_ING: {
    label: '卸货中',
    value: 38
  },
  UNLOAD_COMPLETE: {
    label: '卸货完成',
    value: 40
  },
}
const PORT_TYPE = {
  CONNECT_PORT: {
    label: '接驳港',
    value: 10
  },
  UNLOAD_PORT: {
    label: '卸货港',
    value: 20
  }
}
const CONTRACT_BUSINESS_TYPE = {
  DANCI: {
    label: '单次',
    value: 10
  },
  CHANGQI: {
    label: '长期',
    value: 20
  },
  DUNWEI: {
    label: '吨位',
    value: 30
  }
}
// 回单状态
const RECEIPT_DELIVERY_STATUS = {
  XHQD: {
    label: '卸货签单',
    value: 10,
    disabled: true
  },
  QDWSD: {
    label: '签单未收到',
    value: 20,
    disabled: true
  },
  QDSD: {
    label: '签单收到',
    value: 30,
    disabled: false
  },
  QDFC: {
    label: '签单返厂',
    value: 40,
    disabled: false
  }
}
const BILL_INFO_TYPE = {
  HAI: {
    label: '海船视图',
    value: 1,
  },
  BO: {
    label: '驳船视图',
    value: 0,
  }
}
const WAYBILL_TEMPLATE_INFO_TYPE = {
  NORMAL: {
    label: '正常',
    value: 10,
  },
  OTHER: {
    label: '其他',
    value: 20,
  }
}
const contractStatus = {
  WU: {
    label: '合同未确认',
    value: 0
  },
  WEI: {
    label: '无章合同',
    value: 10
  },
  DAN: {
    label: '单章合同',
    value: 20
  },
  SHUANG: {
    label: '双章合同',
    value: 30
  }
}
export default {
  BUSINESS_CATEGORY,
  CONTRACT_TYPE,
  CONTRACT_STATUS,
  CANCELLATION_STATUS,
  CUSTOMER_TYPE,
  CUSTOMER_CONTACT_TYPE,
  PAYMENT_METHOD,
  BUSINESS_STATUS,
  BOOKING_STATUS,
  TRANSPORT_TYPE,
  ORDER_TYPE,
  INCOME_EXPENSE_DIRECTION,
  ACCOUNT_STATUS,
  BUSINESS_TYPE,
  BILL_STATUS,
  ACCOUNT_BILL_TYPE,
  CARGO_HAULAGE_BUSINESS_TYPE,
  CARGO_HAULAGE_BILL_STATUS,
  CARRIER_TYPE,
  CARRIER_BILL_STATUS,
  COLLECTION_STATUS,
  APPLY_STATUS,
  PAYMENT_STATUS,
  INVOICE_STATUS,
  RECEIPT_STATUS,
  WRITTEN_OFF_STATUS,
  IS_EMPTY_INVOICE,
  INVOICE_TYPE,
  INVOICE_DIRECTION,
  CUSTOMS_STATUS,
  CARGO_SOURCE,
  ENTRY_FLAG,
  ATTACHMENT_BUSINESS_TYPE,
  OPER_LOG_TYPE,
  INCOME_BILL_STATUS,
  COST_BILL_STATUS,
  INVOICE_GENERATE_STATUS,
  INVOICE_WRITE_OFF_WORKBENCH_SOURCE,
  IN_STOCK_TYPE,
  STOCK_CHANGE_HISTORY_TYPE,
  COST_TYPE_INCOME,
  COST_TYPE_EXPENSE,
  YES_OR_NO,
  PRE_PORT_TRANSPORT_TYPE,
  IS_DANGEROUS_GOODS,
  LADING_FILE_SOURCE,
  CUSTOMER_INCOME_BILL_STATUS,
  COST_BILL_FINANCE_STATUS,
  BILL_INCOME_FINANCE_STATUS,
  BILL_COST_FINANCE_STATUS,
  RECEIPT_CATEGORY,
  RECEIPT_METHOD,
  BILL_PAY_TYPE,
  CUSTOMER_ACCOUNT_TYPE,
  BILL_FINANCE_COMMIT_STATUS,
  BUILK_SETTLEMENT_UNIT,
  BUILK_TRANSPORT_TYPE,
  BUILK_INVENTORY_STATUS,
  BUILK_OPERATION_TYPE,
  IMPORT_EXPORT_TYPE,
  PAYMENT_CATEGORY,
  EMPTY_FULL_TYPE,
  BUILK_NEXT_STATUS,
  COST_TYPE,
  CUSTOMER_NEW_TYPE,
  SHIPOWNER_RELATION_TYPE,
  SHIP_TYPE,
  GOODS_SOURCE_TYPE,
  PAYMENT_CYCLE_TYPE,
  INVENTORY_TYPE,
  BULK_SCENE_SHIP_STOWAGE_STATUS,
  BULK_WAYBILL_STATUS,
  INCOME_INVENTORY_STATUS,
  PAYMENT_TYPE,
  WORKING_HOURS_TYPE,
  AUDIT_STATUS,
  WAYBILL_STATUS,
  COST_PRICE_CONFIRM_INVENTORY_STATUS,
  PORT_TYPE,
  CONTRACT_BUSINESS_TYPE,
  COST_PRICE_CONFIRM_INFO_STATUS,
  INCOME_INVENTORY_BILL_STATUS,
  INCOME_INVENTORY_APPROVAL_STATUS,
  RECEIPT_DELIVERY_STATUS,
  BILL_INFO_TYPE,
  WAYBILL_TEMPLATE_INFO_TYPE,
  COST_INVENTORY_STATUS,
  contractStatus
}
